import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';
import { hash } from 'rsvp';
import { SqlImportDatabase } from 'cio/utils/sql-import';

export default class SqlImports extends Route {
  @service store!: DS.Store;

  async model() {
    let { type } = this.paramsFor('sql-imports') as { type: SqlImportDatabase };
    let segments = await this.store.findAll('short-segment');

    return hash({
      type,
      sqlImports: this.store.query('sql-import', { database: type }),
      segments: segments.filterBy('isManual', true),
    });
  }
}
